import {
  MatchedSearchableItem,
  SearchableItem
} from 'front-end/src/components/common/selectEntitiesForm'
import { RecurringEventModelAsAdmin } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { convertSearchableToMatchedItem } from 'front-end/src/components/common/selectEntitiesForm/utils'
import { compareScore } from 'front-end/src/components/common/selectEntitiesForm/SortedEntitiesBasedOnSelection'
import { selectedEventsType } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/event-modal/event-selector/EventSelector'

export const getAdditionalEvents = (
  suggestedEvents,
  suggestedRecEvents,
  searchedRecEvents
) => {
  const parentIds = suggestedEvents
    .filter((searchableItem) => searchableItem.item.original.recurring_event_id)
    .map((searchableItem) => searchableItem.item.original.recurring_event_id)
    .filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i)

  const allSuggestedIds = suggestedRecEvents.map(
    (searchableItem) => searchableItem.item.id
  )

  return parentIds
    .map((parentId) => {
      if (!allSuggestedIds.includes(parentId)) {
        suggestedEvents = suggestedEvents.filter(
          (el) => el.item.original.recurring_event_id === parentId
        )
        return convertSearchableToMatchedItem(
          searchedRecEvents.find(
            (searchableItem) => searchableItem.id === parentId
          ),
          0,
          ''
        )
      }
      return null
    })
    .filter((n) => n)
}

export const getSearchableOccurrences = (
  searchableItem: MatchedSearchableItem,
  searchableEvents: SearchableItem[],
  search: string
) => {
  if (searchableItem.item.type === 'RecurringEventModelAsAdmin') {
    const recEvent = searchableItem.item
      .original as unknown as RecurringEventModelAsAdmin
    const occurrencesIds = recEvent.events.map((item) => item.id)
    return searchableEvents
      .filter((item) => occurrencesIds.includes(item.id))
      .sort((a, b) => {
        return a.id < b.id ? -1 : 1
      })
      .map((item) =>
        convertSearchableToMatchedItem(
          item,
          item.text.indexOf(search) ? item.text.indexOf(search) : -1,
          search
        )
      )
  }
  return undefined
}

export const getSuggestedItemsWithoutOccurrences = (suggestedEvents) => {
  return suggestedEvents.filter(
    (searchableItem) => !searchableItem.item.original.recurring_event_id
  )
}

export const getSortedEvents = (items, selectedIds) => {
  return items.sort((a, b) => {
    const aSelected = selectedIds.includes(a.item.id)
    const bSelected = selectedIds.includes(b.item.id)
    if (aSelected !== bSelected) {
      return aSelected ? -1 : 1
    }

    return compareScore(a, b)
  })
}

export const getSortedRecEvents = (items, selectedIds) => {
  return items.sort((a, b) => {
    const aOccurrenceIds = a.item.original.events?.map(
      (occurrence) => occurrence.id
    )

    const bOccurrenceIds = b.item.original.events?.map(
      (occurrence) => occurrence.id
    )

    const aSelected =
      selectedIds.recEvents.includes(a.item.id) ||
      aOccurrenceIds?.some((oid) => selectedIds.events.includes(oid))
    const bSelected =
      selectedIds.recEvents.includes(b.item.id) ||
      bOccurrenceIds?.some((oid) => selectedIds.events.includes(oid))

    if (aSelected !== bSelected) {
      return aSelected ? -1 : 1
    }

    return compareScore(a, b)
  })
}

export const getChangedSelectedEvents = (
  eventId: number,
  isRecurring = false,
  selectedEvents: selectedEventsType,
  recEvent?: RecurringEventModelAsAdmin
) => {
  let newEvents = [...selectedEvents.events]
  let newRecEvents = [...selectedEvents.recEvents]
  const occurrenceIds = recEvent?.events.map((e) => e.id) || []

  if (isRecurring) {
    // if is represented in recEvents, remove it (uncheck)
    if (newRecEvents.includes(eventId)) {
      newRecEvents = newRecEvents.filter((id) => id !== eventId)
    }
    // if is NOT represented in recEvents, push it and remove all occurrences from selected events (check)
    else {
      newRecEvents.push(eventId)
      newEvents = newEvents.filter((id) => !occurrenceIds.includes(id))
    }
  } else {
    // if parent recurring event is selected, remove it and select all occurrences
    if (recEvent && newRecEvents.includes(recEvent.id)) {
      newRecEvents = newRecEvents.filter((id) => id !== recEvent.id)
      newEvents.push(...occurrenceIds)
    }

    // if event is represented in events, remove it (uncheck)
    if (newEvents.includes(eventId)) {
      newEvents = newEvents.filter((id) => id !== eventId)
    }
    // if event is NOT represented in events, push it (check)
    else {
      newEvents.push(eventId)
    }

    // if all occurrences are checked, add parent recurring event and remove all occurrences
    if (occurrenceIds.every((val) => newEvents.includes(val))) {
      recEvent && newRecEvents.push(recEvent.id)
      newEvents = newEvents.filter((id) => !occurrenceIds.includes(id))
    }
  }

  newRecEvents = [...new Set<number>(newRecEvents)] // remove duplicities
  newEvents = [...new Set<number>(newEvents)] // remove duplicities

  return { newRecEvents, newEvents }
}
